import { render, staticRenderFns } from "./iconLoader.vue?vue&type=template&id=17bc10ca&scoped=true&"
import script from "./iconLoader.vue?vue&type=script&lang=js&"
export * from "./iconLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bc10ca",
  null
  
)

export default component.exports